// extracted by mini-css-extract-plugin
module.exports = {"tabsRoot":"Tabs_tabsRoot__hg6nf","tabsContainer":"Tabs_tabsContainer__jSpun","tabStyle":"Tabs_tabStyle__tfmLQ","previous":"Tabs_previous__20BFr","next":"Tabs_next__2M4_u"};